import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _isEmpty from 'lodash/isEmpty';
import { AVAILABLE_FIELD, PRICE_FIELD } from './CartAdjustments.constants';
import ItemNotAvailableAdjustment from './components/ItemNotAvailableAdjustment';
import PriceChangeAdjustment from './components/PriceChangeAdjustment';
export function getItemsChangedCopy() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var numberOfAdjustments = items.length;
  if (!numberOfAdjustments) {
    return '';
  }
  if (numberOfAdjustments === 1) {
    return 'One of the items in your cart has changed';
  }
  return "".concat(numberOfAdjustments, " of the items in your cart have changed");
}
export function getComponentForAdjustment() {
  var _COMPONENT_BY_ADJUSTM;
  var adjustment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var COMPONENT_BY_ADJUSTMENT = (_COMPONENT_BY_ADJUSTM = {}, _defineProperty(_COMPONENT_BY_ADJUSTM, PRICE_FIELD, PriceChangeAdjustment), _defineProperty(_COMPONENT_BY_ADJUSTM, AVAILABLE_FIELD, ItemNotAvailableAdjustment), _COMPONENT_BY_ADJUSTM);
  return COMPONENT_BY_ADJUSTMENT[adjustment.toLowerCase()];
}
function separateAdjustments() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _item$changes = item.changes,
    changes = _item$changes === void 0 ? [] : _item$changes,
    itemUuid = item.uuid;
  var supportedChanges = changes.filter(function (_ref) {
    var field = _ref.field;
    return !!getComponentForAdjustment(field);
  });
  var modifierAdjustments = supportedChanges.filter(function (_ref2) {
    var uuid = _ref2.object_id;
    return uuid !== itemUuid;
  });
  var itemAdjustments = supportedChanges.filter(function (_ref3) {
    var uuid = _ref3.object_id;
    return uuid === itemUuid;
  });
  return [itemAdjustments, modifierAdjustments];
}
export function getDeletedModifiers() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var modifierAdjustments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var modifiers = item.item_variation_data.modifiers;
  return modifierAdjustments.map(function (_ref4) {
    var modifierUuid = _ref4.object_id,
      modifierField = _ref4.field,
      newValue = _ref4.new_value;
    if (modifierField === AVAILABLE_FIELD && !newValue) {
      return modifiers.find(function (_ref5) {
        var uuid = _ref5.uuid;
        return uuid === modifierUuid;
      });
    }
    return null;
  }).filter(Boolean);
}
export function getAdjustmentForItem() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _separateAdjustments = separateAdjustments(item),
    _separateAdjustments2 = _slicedToArray(_separateAdjustments, 2),
    itemAdjustments = _separateAdjustments2[0],
    modifierAdjustments = _separateAdjustments2[1];
  if (_isEmpty(itemAdjustments)) {
    return null;
  }
  var _itemAdjustments = _slicedToArray(itemAdjustments, 1),
    itemAdjustment = _itemAdjustments[0];
  var itemField = itemAdjustment.field,
    itemNewValue = itemAdjustment.new_value;
  if (itemField === AVAILABLE_FIELD && !itemNewValue) {
    return itemAdjustment;
  }
  var description = '';
  if (!_isEmpty(modifierAdjustments)) {
    var deletedModifiers = getDeletedModifiers(item, modifierAdjustments);
    var deletedModifierNames = deletedModifiers.map(function (_ref6) {
      var name = _ref6.name;
      return name;
    });
    if (!_isEmpty(deletedModifiers)) {
      description = "No ".concat(deletedModifierNames.join(', '));
    }
  }
  return _objectSpread(_objectSpread({}, itemAdjustment), {}, {
    description: description
  });
}
export function filterItemsWithAdjustments() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return items.filter(function (item) {
    var adjustment = getAdjustmentForItem(item);
    return !_isEmpty(adjustment);
  });
}
export function hasAdjustments() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (_isEmpty(items)) {
    return false;
  }
  return !_isEmpty(filterItemsWithAdjustments(items));
}